export const getStyles = () => {
    const styles = {
        option: {
            wordBreak: 'break-all',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'initial',
        }
    };
    return styles;
};